import { Component, Input, HostBinding } from '@angular/core';
import { SpinnerSizes } from '../spinner/spinner.component';

enum ExpandTypes {
  BLOCK = 'block', // cover parent element
  FULL_SCREEN = 'full-screen', // cover body element (i.e. full screen)
  INLINE = 'inline', // cover body element (i.e. full screen)
}

@Component({
  moduleId: module.id,
  selector: 'loading',
  templateUrl: './loading.component.html',
})
export class LoadingComponent {
  @Input() size: SpinnerSizes | string = SpinnerSizes.LARGE;
  @Input() color = 'blue';
  @Input() expand: ExpandTypes | string = ExpandTypes.BLOCK;
  @HostBinding('class') get cssClasses() {
    return `loading loading--expand-${this.expand}`;
  }
}
